<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<form [formGroup]="technicalResourcesForm" *ngIf="!isLoading">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 subsection">
    <p-table
      #technicalResourcesTable
      id="technical-resources"
      [value]="technicalResourcesForm?.value?.technicalResources"
      [scrollHeight]="'150px'"
      [rowTrackBy]="rowTrackByFunction">
      <!-- HEADER -->
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20%">{{ 'regep.eeg-energy-producers.technical-resource' | translate }}</th>
          <th>{{ 'regep.eeg-energy-producers.energy-producer-id' | translate }}</th>
          <th *ngIf="isEdit">{{ 'regep.eeg-energy-producers.master-id' | translate }}</th>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-resource let-i="rowIndex">
        <tr formArrayName="technicalResources">
          <td style="width: 20%">#{{ i + 1 }}</td>
          <td>
            {{ resource.energy_producer_id }}
            <div
              *ngIf="i >= 1 && !isReadOnly && !isEdit && isLastTechnicalResource(i)"
              (click)="deleteTechnicalResource(i)"
              class="pi pi-trash delete-id-btn"></div>
          </td>
          <td *ngIf="isEdit" [formGroupName]="i">
            <input
              class="ui-input pInputText full-width"
              pInputText
              [name]="'master_id_' + i"
              (change)="technicalResourceUpdated($event, i)"
              [attr.disabled]="isReadOnly == true ? true : null"
              formControlName="master_id" />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="2">{{ 'overview.no-data-available' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="!isReadOnly && !isEdit" class="ui-g-12 field-rows subsection plus-btn">
    <i (click)="addTechnicalResource()" class="pi pi-plus plus-icon" data-testId="add-technical-resource"></i>
    <label class="ui-g-5 field-label">{{ 'regep.eeg-energy-producers.add-technical-resource' | translate }}</label>
  </div>
</form>
